export default __webpack_public_path__ + "static/media/Brow_3_C5.cd807c2d.svg";